import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const FavouriteListCard = () => {
  return (
    <div className="col-md-6 col-xxl-3 col-lg-4 mt-3 mt-lg-4">
      <div className="create-favListAdd">
        <div className="favListing d-flex">
          {/* Left Circle */}
          <div className="favListing-lft">
            <Skeleton squre width={50} height={50} />
          </div>

          {/* Right Content */}
          <div className="favListing-rht">
            <a>
              <Skeleton width="70%" height={16} />
            </a>
            <ul className="mt-2">
              <li>
                <Skeleton width={50} height={14} />
              </li>
              <li>
                <i className="fa-solid fa-circle"></i>
              </li>
              <li>
                <Skeleton width={130} height={14} />
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="favListing-links">
          <a className="favListing-links-edit">
            <Skeleton width={60} height={18} />
          </a>
          <a className="favListing-links-delete">
            <Skeleton width={60} height={18} />
          </a>
        </div>
      </div>
    </div>
  );
};
